<template>
  <div class="details container">
    <section>
      <div>
        <h4 class="push-down-20 left-if-mobile">
          <span class="d-none d-md-inline">Packing List</span>
          <span v-if="(templateName && name)" class="break-word">
            {{ templateName }}
            <span v-if="nameSet" @click="editName" class="material-symbols-outlined pointer edit">edit</span></span>
        </h4>
        <div class="form" v-if="!nameSet">
          <div class="form-group row no-margin">
            <label class="instructions" v-if="!name" for="name">
              Give your packing list a name to get started!
            </label>
            <label v-else for="name"> Update your packing lists name </label>
            <div class="col-12 no-padding">
              <!-- Hard code the model binding as Android doesn't like the keyup -->
              <input :value="templateName" @input="(evt) => (templateName = evt.target.value)" type="text"
                placeholder="Please enter a name" @keypress.enter="submit()" @keyup="validateName" />
            </div>

            <div class="button-wrapper">
              <div class="col-12">
                <div class="row">
                  <div class="col-6" v-if="name">
                    <button class="btn btn-default push-down-20" @click="cancelEdit" type="button">
                      Cancel
                    </button>
                  </div>
                  <div :class="{ 'col-6': this.name, 'col-12 ok-btn no-padding': !this.name }">
                    <button :disabled="!nameIsValid" class="push-down-20 pointer ok-button" @click="submit()">
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PackingListTemplateForm',
  components: {},
  props: ['name', 'edit'],
  computed: {
    templateNameFormatted: function () {
      return this.templateName.replace(/\s/g, '-')
    },
  },
  data: function () {
    return {
      showValidHelper: false,
      nameIsValid: false,
      templateName: '',
      nameSet: false,
    }
  },
  mounted() {
    if (this.name) {
      this.templateName = this.name.replace(/-/g, ' ')
      this.nameSet = true
    }
  },
  methods: {
    cancelEdit() {
      this.$emit('edit', false)
      this.nameSet = true
      this.templateName = this.name
      this.nameIsValid = false
    },
    async submit() {
      this.nameSet = true
      this.$emit('edit', false)
      if (this.$store.state.packingListTemplate.current.dbKey) {
        console.log(this.$store.state.packingListTemplate.current.name)
        await this.$store.dispatch('packingListTemplate/update', {
          name: this.templateNameFormatted,
        })
      } else {
        await this.$store.dispatch('packingListTemplate/add', {
          name: this.templateNameFormatted,
        })
      }
      this.$router.push({
        name: 'PackingListTemplateItem',
        params: { name: this.templateNameFormatted },
      })
    },
    validateName() {
      if (!this.templateName) {
        this.nameIsValid = false
      } else {
        this.nameIsValid = true
      }
    },

    updatedName(value) {
      this.templateName = value
    },
    editName() {
      this.nameSet = false
      this.$emit('edit', true)
    },
  },
}
</script>

<style lang='scss' scoped>
.container {
  padding: 0px;

  section {
    width: 100%;
  }
}

.instructions {
  text-align: center;
  width: 100%;
  font-family: "Neue Roman";
  font-size: large;
}

.break-word {
  overflow-wrap: break-word;
}

.large-font {
  font-size: 24px;
  padding-bottom: 10px;
}

.edit {
  position: relative;
  top: 3px;
}

.packing-list-wrapper {
  width: 100%;
  margin: 40px auto;
  padding: 0px;

  @include respond-to('sm') {
    width: 66%;
  }
}

.left-if-mobile {
  text-align: center;
  font-size: larger;
  margin-bottom: 8px;

  @include respond-to('md') {
    text-align: left;
  }
}

.form {
  margin: 20px auto;
  line-height: 2em;
  width: 100%;
  text-align: center;

  @include respond-to('md') {
    margin: 60px auto;
  }

  label {
    @include respond-to('md') {
      text-align: left;
      width: 100%;
      margin-left: 5px;
    }
  }

  input[type='text'],
  textarea {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: white;
    border: none;
    width: 100%;
  }

  .check-mark {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: 32px;
    }
  }

  .green {
    color: $ruxGreen;
  }

  .red {
    color: $ruxRed;
  }

  .button-wrapper {
    width: 100%;
  }

  .push-down-60 {
    margin-top: 60px;
  }

  .input-wrapper {
    margin: 20px 0px;
    border-bottom: solid 1px #dee2e6;
  }

  .ok-button {
    background-color: $ruxGreen;
    height: 40px;
  }
}
</style>